import { parseISO } from 'date-fns';

import { IFacility } from 'common/src/types/interfaces';

import { getStartAndEndDateFields } from 'portal/src/components/common/forms/commonFormFields';

import {
  autoCompleteType,
  datePickerType,
} from '../../../../common/forms/FormFieldTypes';

export const defaultValues = (entity: any = {}) => ({
  endDate:
    entity.endDate && typeof entity.endDate === 'string'
      ? parseISO(entity.endDate)
      : (entity.endDate ?? null),
  facilityId: entity.facilityId ?? '',
  startDate:
    entity.startDate && typeof entity.startDate === 'string'
      ? parseISO(entity.startDate)
      : (entity.startDate ?? null),
});

export const getFacilityProjectFields = (facilities: Partial<IFacility>[]) => {
  const formFieldsConfiguration: Array<datePickerType | autoCompleteType> = [
    {
      placeholder: 'Facility',
      label: 'Facility',
      name: 'facilityId',
      type: 'autocomplete',
      required: true,
      options: facilities.map((facility) => ({
        label: facility.name,
        value: facility.id,
        disabled: !facility.isActive,
        key: facility.id,
      })),
    },
    ...getStartAndEndDateFields({ required: true }),
  ];
  return formFieldsConfiguration;
};
